import type { ProcessedPart, TodoGroupsData } from '~/components/chat/assistant-message/types';
import { isTodoWritePart, isToolInvocationPart } from '~/lib/ai';

export function shouldHidePart(part: ProcessedPart, partIndex: number, todoGroupsData?: TodoGroupsData): boolean {
  if (!todoGroupsData) {
    return false;
  }

  if (partIndex === -1) {
    return false;
  }

  // get current part's parent context if it has one
  const currentPartContext = isToolInvocationPart(part) ? (part.toolInvocation as any).parentToolUseId || null : null;

  // special handling for TodoWrite parts - only show the first one in each context
  if (isTodoWritePart(part)) {
    const contextData = todoGroupsData.contextMap.get(currentPartContext);

    // hide this TodoWrite if it's not the first one in its context
    if (contextData && partIndex !== contextData.firstTodoWriteIndex) {
      return true;
    }

    // don't hide the first TodoWrite (it will show the latest data via Plan component)
    return false;
  }

  // for non-TodoWrite parts, check todo groups
  const contextData = todoGroupsData.contextMap.get(currentPartContext);

  if (!contextData) {
    return false;
  }

  for (const group of contextData.groups) {
    // check if part falls within this group's range
    if (group.endIndex !== null) {
      // completed group - hide parts between start and end (exclusive)
      if (partIndex > group.startIndex && partIndex < group.endIndex) {
        return true;
      }
    } else if (group.isActive) {
      // active group - hide parts after start
      if (partIndex > group.startIndex) {
        return true;
      }
    }
  }

  return false;
}
